<div class="page-padding">
  <div class="panel" style="padding: 1%;">
    <div class="search-options" style="    min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Customer' | translate | async}}</span>
        <mat-select id="select-customer" placeholder="{{'Select Customer' | translate | async}}" [(ngModel)]="selectedCustomer"
                    (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl multiple>
          <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
            {{customer.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Jobsite' | translate | async}}</span>
        <mat-select id="select-jobsite" placeholder="{{'Select Job Site' | translate | async}}" [(ngModel)]="selectedJobsite"
                    (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl multiple>
          <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
            {{jobsite.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Machine' | translate | async}}</span>
        <mat-select id="select-equipment-serialno" placeholder="{{'Select Machine' | translate | async}}"
                    [(ngModel)]="selectedEquipment" ngDefaultControl multiple>
          <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
            {{equipment.SerialNumber}} ||  {{equipment.UnitNumber}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Family' | translate | async}}</span>
        <mat-select id="select-type" placeholder="{{'Select Family' | translate | async}}" [(ngModel)]="selectedFamily" (selectionChange)="loadModelList()"
                    ngDefaultControl multiple>
          <mat-option [value]="type.Id" *ngFor="let type of  _favouriteDialogService.availableFamilyList">
            {{type.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Model' | translate | async}}</span>
        <mat-select id="select-model" placeholder="{{'Select Model' | translate | async}}" [(ngModel)]="selectedModel" ngDefaultControl
                    multiple>
          <mat-option [value]="model.Id" *ngFor="let model of modelList">
            {{model.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Form Category' | translate | async}}</span>
        <mat-select id="select-category" placeholder="{{'Select Form Category' | translate | async}}" [(ngModel)]="selectedCategory"
                    (selectionChange)="LoadForms()" ngDefaultControl multiple>
          <mat-option [value]="cat.Id" *ngFor="let cat of formCatList">
            {{cat.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Form Name' | translate | async}}</span>
        <mat-select id="select-forms" placeholder="{{'Select Form Name' | translate | async}}" [(ngModel)]="selectedForms"
                    ngDefaultControl multiple>
          <mat-option [value]="form.Id" *ngFor="let form of formList">
            {{form.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="bottom-row" style="flex-direction: row-reverse;">
        <div class="flex flex--align-center">
          <a class="button" (click)="ResetFields();"><span class="button__text">{{'Reset' | translate | async}}</span></a>
          <a class="button button--primary" (click)="submitSelection()">
            <i class="material-icons button__icon">search</i><span class="button__text">{{'Perform Search' | translate | async}}</span>
          </a>
        </div>
      </div>
    </div>


  </div>
  <div class="panel" style="display: flex; flex-direction: column;">
    <div class="search-pan">
      <div style="float: left;">
        <span class="tabheader">{{'AVAILABLE FORMS' | translate | async}}</span>
      </div>
      <div style="float: right;" *ngIf="isAdmin">
        <a class="button button--primary" (click)="CreateNewForm()">
          <span class="button__text">{{'Create New Form' | translate | async}}</span>
        </a>
      </div>
    </div>
    <div style="padding: 1%; background-color: #F5F8FB;">
      <div style="margin-left: 39%; min-height:150px;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
      </div>
      <div *ngIf="AvailbleFilteredDigitalForms != null && !loading">
        <table class="table table--full-width table--striped table--hover">
          <thead>
            <tr>
              <th>{{'Form Name' | translate | async}}</th>
              <th>{{'Form Category' | translate | async}}</th>
              <th>{{'Linked Models' | translate | async}}</th>
              <th>{{'Linked Customers' | translate | async}}</th>
              <th *ngIf="isAdmin==true">{{'Edit' | translate | async}}</th>
              <th *ngIf="isAdmin==true">{{'Copy' | translate | async}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="noRecords">
              <td>
                <div style="display: block;font-size: larger;font-weight: bolder;">
                  <span style="color: red; font-style: italic;">{{'No Data Found - please can reset your selection and try again.' | translate | async}}</span>
                </div>
              </td>
            </tr>
            <ng-container *ngFor="let forms of AvailbleFilteredDigitalForms">
              <tr>
                <td class=" columncell" title="{{forms.FormName}}">{{forms.FormName}}</td>
                <td class=" columncell" title="{{forms.CatName}}">{{forms.CatName}}</td>
                <td class="columncell CelltextWrap" title="{{forms.ModelsList}}">{{forms.ModelsList}}</td>
                <td class="columncell CelltextWrap" title="{{forms.CustomerList}}">{{forms.CustomerList}}</td>

                <td class="columncell" *ngIf="isAdmin">
                  <a (click)="redirectToEdit(forms.FormId)" class="linkbutton" title="{{'Edit Form' | translate | async}}">
                    <i class="material-icons button__icon">create</i>
                  </a>
                </td>
                <td class="columncell" *ngIf="isAdmin">
                  <a (click)="OpenCopyFormDialog(forms.FormId)" class="linkbutton" title="{{'Copy Form' | translate | async}}">
                    <i class="material-icons button__icon">content_copy</i>
                  </a>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>